﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customInfopageList from './tpl/customInfopageList.html';
import View_customInfopageListItem from './customInfopageListItem';

export default Marionette.CollectionView.extend({
    tagName: 'customInfopageList',
    childViewContainer: '#customInfopageList',
    childView: View_customInfopageListItem,
    getTemplate: function () {
        return tpl_customInfopageList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
